import type { ComponentChildren } from "preact";
import { h } from "preact";

export const FooterText = ({ children }: { children: ComponentChildren }) => {
    return <p className={`footerText`}>{children}</p>;
};
